import React from "react";
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormInput from '../../../../library/form/components/FormInput';
import FormCheckbox from '../../../../library/form/components/FormCheckbox';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'

const ItemTechEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam: {sview:'itemTech'} }} contentStyle={{ height: '350px' }}
            formStyle={{ width: '450px' }} formTitle={<FormTitle formObject={formObject} value="Advanced Configuration" />}
        >
            <div className="uiSingleColumn">
                <div className="uiGridCol">
                    <ul>
                        <li>
                            <div className="uiCenter uiSectionDividerTitle">
                                <SarasTrans value="Production &amp; Sales config" />
                            </div>
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isMake" }} value="Can Make" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "isMake" }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isSell" }} value="Can Sell" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "isSell" }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isExpire" }} value="Can Expire" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "isExpire" }}
                            />
                        </li>                        
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "pricingMode" }} value="Pricing Mode" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "ac", paramName: "pricingMode", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isMarketDriven" }} value="Market Driven Price" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "isMarketDriven" }}
                            />
                        </li>
                        <li>
                            <div className="uiCenter uiSectionDividerTitle">
                                <SarasTrans value="Inventory config" />
                            </div>
                            <span className="uiLbl">
                                <SarasTrans value="Inventory Mode" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "ac", paramName: "childGranularity", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "inventoryMode" }} value="Inventory Control" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "ac", paramName: "inventoryMode", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isTrack" }} value="Track Inventory" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey='' roClass="uiSpacerH5"
                                action={{ InputType: "onOff", paramName: "isTrack" }}
                            />
                        </li>
                        <li>
                            <div className="uiCenter uiSectionDividerTitle">
                                <SarasTrans value="Type config" />
                            </div>
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isConsign" }} value="Is Consignment" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "isConsign" }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isAsset" }} value="Is Asset" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "isAsset" }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isService" }} value="Is Service" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", paramName: "isService" }}
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </FormDialog>
    )
}

export default withView(ItemTechEditor, "itemTech", "docAttributeValue,itemTech")